import type { Config as DriverConfig } from 'driver.js';
import React from 'react';

interface IDocumentationContext {
  documentation: Record<string, DriverConfig>;
  running: boolean;
  setDocumentation: (arg: Record<string, DriverConfig>) => void;
  setRunning: (arg: boolean) => void;
}

const DocumentationContext = React.createContext<IDocumentationContext>({
  documentation: {},
  running: false,
  setDocumentation: () => {},
  setRunning: () => {},
});

export default DocumentationContext;
